import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import ExcludeFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/ExcludeFilter";
import type { OpportunityListType } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

export default class FindExcludeByStaticListsFilter extends ExcludeFilter<
    readonly string[],
    readonly OpportunityListType[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<readonly string[], readonly OpportunityListType[]>) {
        super(deps);
    }

    getFullSelection(): readonly string[] | undefined {
        return this.options.map((c) => c.opportunityListId);
    }
}
